import React from 'react';
import {T} from '../../../utils/I18n/I18n';
import {useListingContext} from '../../../context/ListingContext';

const PageSize = () => {
    const {listingParams, setListingParams} = useListingContext();

    const onChange = (event) => {
        setListingParams({
            ...listingParams,
            pageSize: parseInt(event.target.value, 10),
            currentPage: 1,
        });
    };

    return (
        <div className="pageSizeDiv">
            <span className="sortSpan">
                <T id="category.pageSizeLabel" />
            </span>
            <div className="pageSizeOptions">
                <select value={listingParams.pageSize} onChange={onChange}>
                    <option value="36">36</option>
                    <option value="96">96</option>
                </select>
            </div>
            <span className="pageSizeLabel"><T id="cart.perPage" /></span>
        </div>
    );
};

export default PageSize;
